import { wrapper, getWrapper } from '../request';
export var LikeTheme = wrapper('vote')('like');
export var StarTheme = wrapper('vote')('star');
export var StarList = getWrapper('vote')('starList');
export var LikeList = getWrapper('vote')('likeList');